var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/nam.phamanh/Documents/Nam/git/cs/lazada/node_modules/_nunjucks-loader@2.4.9@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/component/baseui/templates/msg.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"T_";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += " m-chatpanel-item m-chatpanel-item-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "side"), env.opts.autoescape);
output += " m-chatpanel-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += " ";
if(runtime.contextOrFrameLookup(context, frame, "isFollow")) {
output += " follow ";
;
}
if(runtime.contextOrFrameLookup(context, frame, "type")) {
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "type"), env.opts.autoescape);
;
}
output += "\" data-mid=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "mid"), env.opts.autoescape);
output += "\"";
if(runtime.contextOrFrameLookup(context, frame, "isFirst")) {
output += " tabindex=\"0\" aria-label=\"welcome\"";
;
}
output += ">\n  <div class=\"alime-bubble _content-holder chat";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "contentType"), env.opts.autoescape);
output += "\">\n    ";
if(runtime.contextOrFrameLookup(context, frame, "side") == "left" || runtime.contextOrFrameLookup(context, frame, "side") == "left card-loading") {
output += "\n    <div class=\"alime-";
if(runtime.contextOrFrameLookup(context, frame, "name") == "agent") {
output += "agent";
;
}
else {
output += "robot";
;
}
output += " _block";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "loadingModifier"), env.opts.autoescape);
output += "\">\n      <div class=\"J_Body body message-body ";
if(runtime.contextOrFrameLookup(context, frame, "type")) {
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "type"), env.opts.autoescape);
output += "-body";
;
}
output += "\">\n        <div class=\"J_Content content\">\n          ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "content")), env.opts.autoescape);
output += "\n        </div>\n      </div>\n    </div>\n    ";
;
}
else {
output += "\n      <div class=\"J_Body body message-body ";
if(runtime.contextOrFrameLookup(context, frame, "type")) {
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "type"), env.opts.autoescape);
output += "-body";
;
}
output += "\">\n        <div class=\"J_Content content\">\n          ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "content")), env.opts.autoescape);
output += "\n        </div>\n      </div>\n    ";
;
}
output += "\n  </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/component/baseui/templates/msg.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/component/baseui/templates/msg.html
// module id = 179
// module chunks = 0 1